import { InhouseTicketSystemType } from '@api';
import {
  getValueByPath,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { VenueInhouseTicketSystemTableRowType } from '../../data';

type VenueInhouseTicketSystemTableRowPropsType = {
  venueInhouseTicketSystem: InhouseTicketSystemType;
  row: VenueInhouseTicketSystemTableRowType;
};
export const VenueInhouseTicketSystemTableRow: React.FC<VenueInhouseTicketSystemTableRowPropsType> = ({
  venueInhouseTicketSystem,
  row,
}) => {
  const { t } = useTranslation('venueDetailsOverview');

  const label = t(`VENUE_INHOUSE_TICKET_SYSTEM.ROWS.${row.label}`);
  const value = getValueByPath(venueInhouseTicketSystem, row.accessor);

  const getRenderValue = () => {
    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'ticketSystem':
      case 'notes':
        return String(value);
    }
  };
  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};

